/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 *
 * This software is the proprietary information of Paul Ostrowski.
 * Unauthorized copying, modification, or distribution of this code, via any medium, is strictly prohibited.
 * This code is proprietary and confidential.
 *
 * For licensing inquiries, contact Paul Ostrowski at postrowski@gmail.com.
*/

class Speed {
    walk: number = 30;
    burrow: number = 0;
    swim: number = 0;
    climb: number = 0;
    fly: number = 0;
    hover: boolean = false;
    notes: string | null = null;
}

export default Speed;